var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Operate',{ref:"operate",attrs:{"games":_vm.games,"types":_vm.types,"newbtn":true,"store":"game","user_type":_vm.User.user_type,"bind":2,"only-six":_vm.Running.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }